export default (ctx, html) => html`
  <aofl-drawer id="drawer" ?open="${ctx.open}">
    <slot></slot>
  </aofl-drawer>
`;
